module.exports = __webpack_public_path__ + "img/enter_name_UK.36ad7035.svg";